// routes editables 3 jours avant le terme
export const routes = [
    'route-f718de97-b050-49e2-8132-9a295e96413c', //granit rose
    'route-07b7320d-49d2-40ee-9998-815f2143d1ef', //emeraude
    'route-92643b93-6dea-4fc8-afac-3a258d907fa6', //stevenson
    'route-4752db98-7a15-4bae-9553-1d7bd1413e42', //St Guilhem
    'route-16aaf4c5-e1ed-418b-bab8-25ae2c7cd5da', //compostelle
    'route-0df9f1ce-a010-4bb3-af62-aa09b2a6dc7c', //célé
    'route-9992153d-cf0c-407e-b648-919e42647ed5', //rocamadour
    'route-fb8c495d-4229-4d54-ae09-a903c9c1649f' //aubrac
]